/**
 * JV HEADER SEARCH - JAVASCRIPT
 * Mega menu + Search overlay with predictive results + Mobile menu
 */
// Auto-adjust Megamenu Position
document.addEventListener('DOMContentLoaded', function () {
  const navItems = document.querySelectorAll('.jv-header__nav-item');

  navItems.forEach(item => {
    const megamenu = item.querySelector('.jv-megamenu');

    if (megamenu) {
      item.addEventListener('mouseenter', function () {
        // Reset positioning
        megamenu.style.left = '0';
        megamenu.style.right = 'auto';
        megamenu.style.transform = 'none';

        // Wait for next frame to get accurate measurements
        requestAnimationFrame(() => {
          const megamenuRect = megamenu.getBoundingClientRect();
          const viewportWidth = window.innerWidth;

          // Check if megamenu goes off screen on the right
          if (megamenuRect.right > viewportWidth) {
            megamenu.style.left = 'auto';
            megamenu.style.right = '0';
          }

          // Check if megamenu goes off screen on the left
          if (megamenuRect.left < 0) {
            megamenu.style.left = '0';
            megamenu.style.right = 'auto';
          }
        });
      });
    }
  });
});


(function () {
  'use strict';

  // DOM Elements
  const menuIcon = document.querySelector('.jv-header__menu-icon');
  const searchIconMobile = document.querySelector('.jv-header__search-icon');
  const searchInputDesktop = document.querySelector('.jv-header__search-input');
  const searchInputMobile = document.getElementById('mobile-search-input');
  const searchButton = document.querySelector('.jv-header__search-button');
  const searchOverlay = document.getElementById('search-overlay');
  const mobileDrawer = document.getElementById('mobile-menu-drawer');
  const drawerClose = document.querySelector('.jv-mobile-drawer__close');
  const drawerOverlay = document.querySelector('.jv-mobile-drawer__overlay');
  const overlayCloseMobile = document.querySelector('.jv-search-overlay__close-mobile');
  const searchResults = document.getElementById('search-results');
  const cartCountElement = document.getElementById('cart-count');

  let searchTimeout;
  let currentSearchQuery = '';
  let topupWhitelist = [];

  // Initialize
  function init() {
    loadTopupWhitelist();
    bindEvents();
    updateCartCount();
  }

  // Load Top Up Whitelist from Theme Settings
  function loadTopupWhitelist() {
    // Get whitelist from Shopify theme settings
    const whitelistSetting = window.themeSettings?.topup_products_whitelist || '';

    if (whitelistSetting) {
      // Split by line breaks and trim whitespace
      topupWhitelist = whitelistSetting
        .split('\n')
        .map(name => name.trim())
        .filter(name => name.length > 0);

    }
  }

  // Bind all events
  function bindEvents() {
    // Mobile menu
    if (menuIcon) {
      menuIcon.addEventListener('click', openMobileDrawer);
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeMobileDrawer);
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeMobileDrawer);
    }

    // Mobile submenu toggles
    const mobileToggles = document.querySelectorAll('.jv-mobile-drawer__toggle');
    mobileToggles.forEach(toggle => {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const menuName = this.getAttribute('data-menu');
        const submenu = document.querySelector(`[data-submenu="${menuName}"]`);

        if (submenu) {
          this.classList.toggle('active');
          submenu.classList.toggle('active');
        }
      });
    });

    // Search overlay
    if (searchIconMobile) {
      searchIconMobile.addEventListener('click', openSearchOverlay);
    }

    if (searchInputDesktop) {
      searchInputDesktop.addEventListener('focus', openSearchOverlay);
      searchInputDesktop.addEventListener('input', handleSearchInput);
    }

    if (searchInputMobile) {
      searchInputMobile.addEventListener('input', handleSearchInput);
    }

    if (overlayCloseMobile) {
      overlayCloseMobile.addEventListener('click', closeSearchOverlay);
    }

    if (searchOverlay) {
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) {
          closeSearchOverlay();
        }
      });
    }

    // ESC key to close, Enter to search
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSearchOverlay();
        closeMobileDrawer();
      }
    });

    // Enter key to go to search page
    if (searchInputDesktop) {
      searchInputDesktop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          handleEnterSearch(e);
        }
      });
    }

    if (searchInputMobile) {
      searchInputMobile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          handleEnterSearch(e);
        }
      });
    }

    // Search button click to go to search page
    if (searchButton) {
      searchButton.addEventListener('click', function (e) {
        e.preventDefault();
        handleSearchButtonClick();
      });
    }

    // Cart updates
    document.addEventListener('cart:updated', updateCartCount);
  }

  // Mobile Drawer Functions
  function openMobileDrawer() {
    if (mobileDrawer) {
      mobileDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileDrawer() {
    if (mobileDrawer) {
      mobileDrawer.classList.remove('active');
      document.body.style.overflow = '';

      // Close all submenus
      const submenus = document.querySelectorAll('.jv-mobile-drawer__submenu');
      const toggles = document.querySelectorAll('.jv-mobile-drawer__toggle');

      submenus.forEach(submenu => submenu.classList.remove('active'));
      toggles.forEach(toggle => toggle.classList.remove('active'));
    }
  }

  // Search Overlay Functions
  function openSearchOverlay() {
    if (searchOverlay) {
      searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Focus mobile input if opened from mobile
      if (searchInputMobile && window.innerWidth <= 768) {
        setTimeout(() => searchInputMobile.focus(), 100);
      }
    }
  }

  function closeSearchOverlay() {
    if (searchOverlay) {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';

      // Clear inputs
      if (searchInputDesktop) searchInputDesktop.value = '';
      if (searchInputMobile) searchInputMobile.value = '';

      // Reset results
      currentSearchQuery = '';
      showEmptyState();
    }
  }

  // Search Input Handler
  function handleSearchInput(e) {
    const query = e.target.value.trim();

    // Sync inputs
    if (searchInputDesktop && e.target !== searchInputDesktop) {
      searchInputDesktop.value = query;
    }
    if (searchInputMobile && e.target !== searchInputMobile) {
      searchInputMobile.value = query;
    }

    // Clear previous timeout
    clearTimeout(searchTimeout);

    // Show empty state if no query
    if (!query) {
      currentSearchQuery = '';
      showEmptyState();
      return;
    }

    // Debounce search
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  }

  // Handle Enter key to go to search page
  function handleEnterSearch(e) {
    e.preventDefault();
    const query = e.target.value.trim();

    if (query) {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      window.location.href = `${shopifyRoot}search?q=${encodeURIComponent(query)}`;
    }
  }

  // Handle search button click to go to search page
  function handleSearchButtonClick() {
    const query = searchInputDesktop ? searchInputDesktop.value.trim() : '';

    if (query) {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      window.location.href = `${shopifyRoot}search?q=${encodeURIComponent(query)}`;
    }
  }

  // Perform Search
  function performSearch(query) {
    if (query === currentSearchQuery) return;

    currentSearchQuery = query;
    showLoadingState();

    // Shopify Predictive Search API (use market-aware root URL to get market-prefixed product URLs)
    const shopifyRoot = window.Shopify?.routes?.root || '/';
    fetch(`${shopifyRoot}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
      .then(response => response.json())
      .then(data => {
        displayResults(data);
      })
      .catch(error => {
        console.error('Search error:', error);
        showErrorState();
      });
  }

  // Display Results
  function displayResults(data) {
    if (!searchResults) return;

    const products = data.resources.results.products || [];

    if (products.length === 0) {
      showNoResultsState();
      return;
    }

    // Filtrar produtos do tipo gift-card e top-up
    const filteredProducts = products.filter(product => {
      // Log de debug para verificar o que está chegando da API
      console.log('🔍 Analisando produto:', {
        title: product.title,
        product_type: product.product_type,
        tags: product.tags
      });

      // VERIFICAR SE ESTÁ NA WHITELIST PRIMEIRO
      const isInWhitelist = topupWhitelist.some(whitelistedName => {
        return product.title.trim() === whitelistedName.trim();
      });

      if (isInWhitelist) {
        console.log('✅ WHITELIST - Produto permitido:', product.title);
        // Marcar produto como whitelisted para tratamento especial
        product._isWhitelisted = true;
        return true;
      }

      // Verificar product_type (se disponível)
      const productTypeRaw = (product.product_type || product.type || '').toLowerCase();
      if (productTypeRaw) {
        console.log('   📦 Product Type (raw):', productTypeRaw);

        // Verificar ANTES da normalização (para capturar "top up" com espaço)
        if (productTypeRaw.includes('top up') || productTypeRaw.includes('top-up')) {
          console.log('❌ EXCLUÍDO (top-up type raw):', product.title);
          return false;
        }

        // Agora normalizar e verificar outras variações
        const productType = productTypeRaw.replace(/[\s-_]/g, '');
        console.log('   📦 Product Type (normalizado):', productType);

        if (productType.includes('gift') || productType.includes('card')) {
          console.log('❌ EXCLUÍDO (gift card type):', product.title);
          return false;
        }
        if (productType.includes('topup')) {
          console.log('❌ EXCLUÍDO (top-up type normalizado):', product.title);
          return false;
        }
      } else {
        console.log('   ⚠️  Product Type não disponível na API');
      }

      // Verificar tags
      if (product.tags) {
        const tagsString = (Array.isArray(product.tags) ? product.tags.join(' ') : product.tags).toLowerCase();
        if (tagsString.includes('gift') || tagsString.includes('giftcard')) {
          console.log('❌ EXCLUÍDO (gift card tag):', product.title);
          return false;
        }
        if (tagsString.includes('top-up') || tagsString.includes('topup') || tagsString.includes('top up')) {
          console.log('❌ EXCLUÍDO (top-up tag):', product.title);
          return false;
        }
      }

      console.log('✅ INCLUÍDO:', product.title);
      return true;
    });

    if (filteredProducts.length === 0) {
      showNoResultsState();
      return;
    }

    let html = '';

    filteredProducts.forEach(product => {
      // Preços já vêm em formato decimal como STRING
      const priceDecimal = parseFloat(product.price_min || product.price || 0);
      const comparePriceDecimal = parseFloat(product.compare_at_price_min || product.compare_at_price_max || 0);

      // Formatar preços
      const price = formatMoneyFromDecimal(priceDecimal);
      const comparePrice = comparePriceDecimal > priceDecimal ? formatMoneyFromDecimal(comparePriceDecimal) : null;

      // Imagem
      const imageUrl = product.image || product.featured_image || '';

      // Vendor/Plataforma
      const vendor = product.vendor || 'STEAM';

      // Calcular desconto e montar HTML de preços
      let discountBadge = '';
      let pricesHTML = '';

      // Ocultar preço se for menor que R$ 0,50 OU se estiver na whitelist
      if (priceDecimal >= 0.50 && !product._isWhitelisted) {
        if (comparePriceDecimal > priceDecimal) {
          const discount = Math.round(((comparePriceDecimal - priceDecimal) / comparePriceDecimal) * 100);
          discountBadge = `<span class="jv-product-discount-badge">-${discount}%</span>`;

          // Com desconto: badge à esquerda, preços à direita empilhados
          pricesHTML = `
            ${discountBadge}
            <div class="jv-product-prices-stack">
              <span class="jv-search-product__price-old">${comparePrice}</span>
              <span class="jv-search-product__price">${price}</span>
            </div>
          `;
        } else {
          // Sem desconto: apenas o preço
          pricesHTML = `
            <div class="jv-product-prices-stack">
              <span class="jv-search-product__price">${price}</span>
            </div>
          `;
        }
      }
      // Se preço < 0.50 OU whitelisted, pricesHTML fica vazio

      html += `
        <a href="${product.url}" class="jv-search-product">
          <div class="jv-search-product__image">
            ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy" onerror="this.style.display='none'">` : ''}
          </div>
          <div class="jv-search-product__info">
            <h4 class="jv-search-product__title">${escapeHtml(product.title)}</h4>
            <span class="jv-product-platform-badge">
              ${escapeHtml(vendor)}
            </span>
            <div class="jv-search-product__prices">
              ${pricesHTML}
            </div>
          </div>
        </a>
      `;
    });

    searchResults.innerHTML = html;
  }

  // UI States
  function getI18n(/** @type {string} */ key) {
    const settings = /** @type {any} */ (window).themeSettings;
    return settings?.searchOverlayI18n?.[key] || key;
  }

  function showEmptyState() {
    if (!searchResults) return;
    searchResults.innerHTML = `<div class="jv-search-products__empty"><p style="color: #ffffff;">${getI18n('type_to_search')}</p></div>`;
  }

  function showLoadingState() {
    if (!searchResults) return;
    searchResults.innerHTML = `<div class="jv-search-products__empty"><p style="color: #ffffff;">${getI18n('searching')}</p></div>`;
  }

  function showNoResultsState() {
    if (!searchResults) return;
    searchResults.innerHTML = `<div class="jv-search-products__empty"><p style="color: #ffffff;">${getI18n('no_results')}</p></div>`;
  }

  function showErrorState() {
    if (!searchResults) return;
    searchResults.innerHTML = `<div class="jv-search-products__empty"><p style="color: #ffffff;">${getI18n('error')}</p></div>`;
  }

  // Update Cart Count
  function updateCartCount() {
    // @ts-ignore - window.Shopify.routes.root is provided by Shopify
    fetch((window.Shopify?.routes?.root ?? '/') + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count;
          cartCountElement.style.display = cart.item_count > 0 ? 'block' : 'none';
        }
      })
      .catch(error => console.error('Cart count error:', error));
  }

  // Format Money from Decimal using currency symbol from current market
  function formatMoneyFromDecimal(decimal) {
    const symbol = window.themeSettings?.currencySymbol || '';
    const amount = parseFloat(decimal).toFixed(2);
    return symbol + ' ' + amount;
  }

  // Escape HTML to prevent XSS
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();